// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InputWithValidation-module__formContainer___qUx4C{width:100%;display:flex}.InputWithValidation-module__formContainer___qUx4C .InputWithValidation-module__inputContainer___2F-F0{width:80%;flex:0 0 65%;padding-right:10px}.InputWithValidation-module__skipContainer___1w-k8{padding-top:15px;padding-bottom:40px}", ""]);
// Exports
exports.locals = {
	"formContainer": "InputWithValidation-module__formContainer___qUx4C",
	"inputContainer": "InputWithValidation-module__inputContainer___2F-F0",
	"skipContainer": "InputWithValidation-module__skipContainer___1w-k8"
};
module.exports = exports;
